(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal() {
    var els = document.querySelectorAll('[data-som-reveal]:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(function (e) { e.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (list) {
      list.forEach(function (x) {
        if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (e) { io.observe(e); });
  }

  function colors(root) {
    root.querySelectorAll('[data-som-colors]').forEach(function (box) {
      var img = box.querySelector('[data-som-color-img]');
      var name = box.querySelector('[data-som-color-name]');
      box.querySelectorAll('[data-som-swatch]').forEach(function (b) { if (b.dataset.src) { new Image().src = b.dataset.src; } });
      box.querySelectorAll('[data-som-swatch]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (b.dataset.src) { img.src = b.dataset.src; img.classList.remove('is-swap'); void img.offsetWidth; img.classList.add('is-swap'); }
          img.alt = b.dataset.label + ' alev rengi';
          name.textContent = b.dataset.label;
          box.querySelectorAll('[data-som-swatch]').forEach(function (x) {
            x.setAttribute('aria-pressed', x === b ? 'true' : 'false');
          });
        });
      });
    });
  }

  function sticky() {
    var bar = document.querySelector('[data-som-sticky]');
    if (!bar) return;
    var form = document.querySelector('product-form form[action*="/cart/add"]');
    var main = form && form.querySelector('[type="submit"]');
    if (!main) return;
    bar.querySelector('button').addEventListener('click', function () {
      if (main.disabled) { form.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); return; }
      main.click();
    });
    if (!('IntersectionObserver' in window)) { bar.classList.add('is-on'); return; }
    new IntersectionObserver(function (l) {
      bar.classList.toggle('is-on', !l[0].isIntersecting && l[0].boundingClientRect.top < 0);
    }).observe(main);
  }


  function countdown() {
    document.querySelectorAll('[data-som-count]').forEach(function (el) {
      if (el.dataset.somBound) return;
      el.dataset.somBound = '1';
      var end = new Date(el.dataset.somCount).getTime();
      if (isNaN(end)) return;
      var d = el.querySelector('[data-d]'), h = el.querySelector('[data-h]'), m = el.querySelector('[data-m]'), s = el.querySelector('[data-s]');
      function pad(n) { return n < 10 ? '0' + n : '' + n; }
      function tick() {
        var left = Math.floor((end - Date.now()) / 1000);
        if (left <= 0) { el.hidden = true; return false; }
        el.hidden = false;
        d.textContent = pad(Math.floor(left / 86400));
        h.textContent = pad(Math.floor(left % 86400 / 3600));
        m.textContent = pad(Math.floor(left % 3600 / 60));
        s.textContent = pad(left % 60);
        return true;
      }
      if (!tick()) return;
      var t = setInterval(function () { if (!tick()) clearInterval(t); }, 1000);
    });
  }

  function packs() {
    document.querySelectorAll('[data-som-packs]').forEach(function (box) {
      if (box.dataset.somBound) return;
      box.dataset.somBound = '1';
      var info = box.closest('.product__info-container') || document;
      function apply(v) {
        var q = info.querySelector('input[name="quantity"]');
        if (!q) return;
        q.value = v;
        q.dispatchEvent(new Event('input', { bubbles: true }));
        q.dispatchEvent(new Event('change', { bubbles: true }));
      }
      box.addEventListener('change', function (e) {
        if (e.target.matches('[data-som-pack]')) apply(e.target.value);
      });
      var on = box.querySelector('[data-som-pack]:checked');
      if (on) apply(on.value);
    });
  }

  function announce() {
    document.querySelectorAll('[data-som-ann]').forEach(function (bar) {
      if (bar.dataset.somBound) return;
      bar.dataset.somBound = '1';
      var msgs = bar.querySelectorAll('.somine-ann__msg');
      if (msgs.length < 2 || reduce) return;
      var i = 0;
      setInterval(function () {
        msgs[i].classList.remove('is-on');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('is-on');
      }, (parseInt(bar.dataset.interval, 10) || 5) * 1000);
    });
  }


  function videos(root) {
    root.querySelectorAll('[data-som-videos]').forEach(function (sec) {
      if (sec.dataset.somBound) return;
      sec.dataset.somBound = '1';
      var track = sec.querySelector('[data-som-track]');
      var prev = sec.querySelector('[data-som-prev]');
      var next = sec.querySelector('[data-som-next]');
      function step() { var it = track.querySelector('li'); return it ? it.getBoundingClientRect().width + 20 : 300; }
      function state() {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (max <= 0) { sec.setAttribute('data-fits', ''); } else { sec.removeAttribute('data-fits'); }
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max;
      }
      prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }); });
      next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }); });
      track.addEventListener('scroll', state, { passive: true });
      window.addEventListener('resize', state);
      state();
      var vids = sec.querySelectorAll('video');
      if (reduce) { vids.forEach(function (v) { v.removeAttribute('autoplay'); v.pause(); }); return; }
      if ('IntersectionObserver' in window) {
        var vio = new IntersectionObserver(function (list) {
          list.forEach(function (x) {
            var v = x.target;
            if (x.isIntersecting) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); } else { v.pause(); }
          });
        }, { threshold: 0.25 });
        vids.forEach(function (v) { v.muted = true; vio.observe(v); });
      }
    });
  }


  function bundle(root) {
    root.querySelectorAll('[data-som-bundle]').forEach(function (sec) {
      if (sec.dataset.somBound) return;
      sec.dataset.somBound = '1';
      var btn = sec.querySelector('[data-som-bundle-add]');
      var field = sec.querySelector('[data-som-bundle-variant]');
      var msg = sec.querySelector('[data-som-bundle-msg]');
      if (!btn || !field) return;
      btn.addEventListener('click', function () {
        var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        var body = new FormData();
        body.append('id', field.value);
        body.append('quantity', '1');
        if (cart && cart.getSectionsToRender) {
          body.append('sections', cart.getSectionsToRender().map(function (x) { return x.id; }));
          body.append('sections_url', window.location.pathname);
        }
        btn.disabled = true;
        msg.textContent = '';
        fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', { method: 'POST', headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: body })
          .then(function (r) { return r.json(); })
          .then(function (state) {
            if (state.status) { msg.textContent = state.description || state.message || 'Sepete eklenemedi.'; btn.disabled = false; return; }
            msg.textContent = 'Sepete eklendi.';
            if (cart && cart.renderContents) { cart.renderContents(state); } else { window.location.href = (window.routes && window.routes.cart_url) || '/cart'; }
            btn.disabled = false;
          })
          .catch(function () { msg.textContent = 'Bir sorun oluştu, lütfen tekrar deneyin.'; btn.disabled = false; });
      });
    });
  }


  function addons() {
    document.querySelectorAll('[data-som-addons]').forEach(function (box) {
      if (box.dataset.somBound) return;
      box.dataset.somBound = '1';
      var msg = box.querySelector('[data-som-addons-msg]');
      function say(t) { if (msg) msg.textContent = t; }
      function bubble(state) {
        var sec = state && state.sections && state.sections['cart-icon-bubble'];
        var el = document.getElementById('cart-icon-bubble');
        if (!sec || !el) return;
        var doc = new DOMParser().parseFromString(sec, 'text/html');
        var src = doc.querySelector('.shopify-section');
        if (src) el.innerHTML = src.innerHTML;
      }
      box.addEventListener('change', function (e) {
        var cb = e.target;
        if (!cb.matches('[data-som-addon]')) return;
        cb.disabled = true;
        var add = cb.checked;
        var url = add ? ((window.routes && window.routes.cart_add_url) || '/cart/add.js') : ((window.routes && window.routes.cart_change_url) || '/cart/change.js');
        var payload = add ? { id: cb.value, quantity: 1, sections: 'cart-icon-bubble' } : { id: cb.value, quantity: 0, sections: 'cart-icon-bubble' };
        fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) })
          .then(function (r) { return r.json(); })
          .then(function (state) {
            if (state.status) { cb.checked = !add; say(state.description || state.message || 'İşlem yapılamadı.'); return; }
            say(add ? 'Esans seti sepete eklendi.' : 'Esans seti sepetten çıkarıldı.');
            bubble(state);
          })
          .catch(function () { cb.checked = !add; say('Bir sorun oluştu, lütfen tekrar deneyin.'); })
          .then(function () { cb.disabled = false; });
      });
      // sayfa açıldığında sepetteki esans setlerini işaretle
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var ids = {};
          (cart.items || []).forEach(function (it) { ids[String(it.variant_id)] = true; });
          box.querySelectorAll('[data-som-addon]').forEach(function (cb) { if (ids[cb.value]) cb.checked = true; });
        })
        .catch(function () {});
    });
  }
  window.addEventListener('load', addons);
  document.addEventListener('shopify:section:load', addons);

  function init() { reveal(); colors(document); sticky(); countdown(); packs(); announce(); videos(document); bundle(document); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
  document.addEventListener('shopify:section:load', function (e) { reveal(); colors(e.target); countdown(); packs(); announce(); videos(e.target); bundle(e.target); });
})();
